import { combineReducers } from 'redux';
import user from './login/loginReducer';
import negotiationLot from './negotiationLot/negotiationLotReducer';
import negotiationSubLots from './negotiationSubLot/negotiationSubLotReducer';
import subLotCarOptionals from './carOptionals/carOptionalsReducer';
import usedRentalsSubLots from './RU/usedRentalsSubLotReducer';

export default combineReducers({
    user,
    negotiationLot,
    negotiationSubLots,
    subLotCarOptionals,
    usedRentalsSubLots,
});


// WEBPACK FOOTER //
// ./src/store/reducers/rootReducer.js